export var WeatherWarningLevels;
(function (WeatherWarningLevels) {
    WeatherWarningLevels[WeatherWarningLevels["LEVEL_0"] = 0] = "LEVEL_0";
    WeatherWarningLevels[WeatherWarningLevels["LEVEL_1"] = 1] = "LEVEL_1";
    WeatherWarningLevels[WeatherWarningLevels["LEVEL_2"] = 2] = "LEVEL_2";
    WeatherWarningLevels[WeatherWarningLevels["LEVEL_3"] = 3] = "LEVEL_3";
    WeatherWarningLevels[WeatherWarningLevels["LEVEL_4"] = 4] = "LEVEL_4";
    WeatherWarningLevels[WeatherWarningLevels["NONE"] = 5] = "NONE";
})(WeatherWarningLevels || (WeatherWarningLevels = {}));
//# sourceMappingURL=weatherWarning.js.map